export function filtersMenu() {
	const categoriesBtnOpen = document.querySelector('[data-categories-open]');
	const categoriesWrapper = document.querySelector('.categories-block__wrapper');
	const filterToggleMobile = document.querySelector('[data-mobile-filter-toggle]');

	if (!categoriesBtnOpen || !categoriesWrapper) return;

	const categoriesBtnClose = categoriesWrapper.querySelector('[data-categories-close]');
	if (!categoriesBtnClose) return;

	if (filterToggleMobile) {
		filterToggleMobile.addEventListener('click', () => {
			categoriesWrapper.classList.add('visible');
			document.body.classList.add('scroll-lock');
		});
	}

	categoriesBtnOpen.addEventListener('click', () => {
		categoriesWrapper.classList.add('visible');
		categoriesBtnOpen.classList.remove('white');
		categoriesBtnOpen.classList.add('yellow');
		document.body.classList.add('scroll-lock');
	});

	categoriesBtnClose.addEventListener('click', () => {
		categoriesWrapper.classList.remove('visible');
		document.body.classList.remove('scroll-lock');
		categoriesBtnOpen.classList.add('white');
		categoriesBtnOpen.classList.remove('yellow');
	});
}
